import { render, staticRenderFns } from "./versionAdd.vue?vue&type=template&id=abe6a3fa&scoped=true&"
import script from "./versionAdd.vue?vue&type=script&lang=js&"
export * from "./versionAdd.vue?vue&type=script&lang=js&"
import style0 from "./versionAdd.vue?vue&type=style&index=0&id=abe6a3fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe6a3fa",
  null
  
)

export default component.exports